import React from 'react';

/**
 * Yeniden kullanılabilir döküman şablonu:
 * meta (platform / rol / özet) + adım adım görsel + anlatım.
 */
function DocArticle({ doc }) {
  if (!doc) return null;

  return (
    <article className="doc-article">
      <header className="doc-article__header">
        <h1 className="doc-article__title">{doc.title}</h1>
        <dl className="doc-article__meta">
          <div className="doc-article__meta-row">
            <dt>Platform</dt>
            <dd>{doc.platform}</dd>
          </div>
          <div className="doc-article__meta-row">
            <dt>Kullanıcı Rolü</dt>
            <dd>{doc.role}</dd>
          </div>
        </dl>
        {doc.summary ? (
          <p className="doc-article__summary">{doc.summary}</p>
        ) : null}
      </header>

      <ol className="doc-article__steps">
        {(doc.steps || []).map((step, index) => (
          <li key={`${step.title}-${index}`} className="doc-step">
            <div className="doc-step__media">
              {step.image ? (
                <img
                  src={step.image}
                  alt={step.title}
                  className="doc-step__image"
                  loading="lazy"
                />
              ) : (
                <div className="doc-step__placeholder">Görsel yok</div>
              )}
            </div>
            <div className="doc-step__content">
              <h2 className="doc-step__title">{step.title}</h2>
              <p className="doc-step__body">{step.body}</p>
            </div>
          </li>
        ))}
      </ol>
    </article>
  );
}

export default DocArticle;
